import { Button, CircularProgress } from "@material-ui/core";
import React from "react";

export default function ButtonWithLoadingSpinner({ isLoading, children, ...props }) {
  return (
    <Button {...props} style={{ display: "flex", alignItems: "center" }} disabled={isLoading}>
      {isLoading && <CircularProgress color="inherit" style={{ marginRight: 4, width: 20, height: 20 }} />}
      {children}
    </Button>
  );
}
